import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';

const CostCentersListTable = ({
  children,
  count,
  company, ///////
  subcompany, ////////
  permissions, //////z
  handleToggle = () => {}, ///////
  handleOrderChange = () => {},
  order = '',
  orderBy = '',
  t,
}) => {
  const headers = [
    { variable: 'key', text: t('costCenters.fields.key') + ': ', type: 'h3' },
    { variable: 'name', text: t('costCenters.fields.name') + ': ' },
    {
      variable: 'description',
      text: t('costCenters.fields.description') + ': ',
    },
    {
      variable: 'active',
      text: t('costCenters.fields.active') + ': ',
      boolean: true,
    },
  ];

  const config = {
    actions: t('common.actions'), //Texto de seccion de acciones
    edit: t('common.edit'), //Texto de boton editar
    editPermission: 'acl.cost_centers.update',
    togglePermission: 'acl.cost_centers.toggle',
    editUrl: 'cost_centers', //Url para editar empleado
    propsName: 'costCenter', //de donde se obtienen los props
    company: company,
    subcompany: subcompany,
  };

  const dataCard = {
    rows: children,
    headers: headers,
    config: config,
    permissions: permissions,
    handleClick: handleToggle,
  };

  return (
    <Common.List dataCard={dataCard}>
      <thead>
        <tr>
          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="key"
            handleOrderChange={handleOrderChange}
          >
            {t('costCenters.fields.key')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="name"
            handleOrderChange={handleOrderChange}
          >
            {t('costCenters.fields.name')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="description"
            handleOrderChange={handleOrderChange}
          >
            {t('costCenters.fields.description')}
          </Common.ThSortable>

          <Common.ThSortable
            orderBy={orderBy}
            order={order}
            field="active"
            handleOrderChange={handleOrderChange}
            className="text-center"
          >
            {t('costCenters.fields.active')}
          </Common.ThSortable>

          <th className="text-center">{t('common.actions')}</th>
        </tr>
      </thead>

      <tbody>
        {count === 0 && <Common.EmptyTable colSpan={10} />}
        {children}
      </tbody>
    </Common.List>
  );
};

export default translate()(CostCentersListTable);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/CostCentersListTable.js